export default function GiftDetailSection() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28 overflow-hidden">
      {/* Background Decoration Text - CAMPAIGN DETAIL like PRESENT style */}
      <div className="absolute top-6 left-1/2 -translate-x-1/2 pointer-events-none select-none">
        <p
          className="font-heading text-[28px] sm:text-[44px] md:text-[80px] lg:text-[110px] tracking-[0.08em] md:tracking-[0.1em] text-foreground-100/80 whitespace-nowrap"
          style={{ fontWeight: 300 }}
        >
          CAMPAIGN DETAIL
        </p>
      </div>

      <div className="relative z-10 w-full px-6 md:px-16 pt-6 md:pt-16">
        {/* Section Label - centered */}
        <p className="font-sans text-[13px] tracking-[0.15em] text-foreground-400 mb-10 md:mb-14 text-center">
          CAMPAIGN DETAIL ／ キャンペーン詳細
        </p>

        {/* Image - larger on mobile, full width on PC */}
        <div className="w-full mb-10 md:mb-14">
          <div className="relative w-full mx-auto aspect-[4/3] md:aspect-[16/6]">
            <img
              src="https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/fd80f390cb28a5f407338f3fa4d70e61.jpeg"
              alt="ReFa BEAUTECH SHAMPOO &amp; TREATMENT"
              className="relative w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Campaign Text - centered */}
        <div className="max-w-[1100px] mx-auto text-center">
          <p
            className="font-sans text-[16px] md:text-[20px] lg:text-[22px] tracking-[0.06em] leading-[2.4] text-foreground-700"
            style={{ fontWeight: 300 }}
          >
            対象の展示場をご予約の上ご来場いただいた方の中から
            <strong
              className="text-foreground-950"
              style={{ fontWeight: 500, fontSize: '1.15em' }}
            >
              抽選で100名様
            </strong>
            に、
            <br className="hidden md:block" />
            ReFa BEAUTECH SHAMPOO &amp; TREATMENTをプレゼント
          </p>
        </div>
      </div>
    </section>
  );
}